<template >
  <base-dialog-form ref="gestProductDialog" :title="computedTitle" :text="productCode" color="secondary"
    icon="mdi-cube-outline">
    <template v-slot:actions v-if="method !== 'VIEW'">
      <v-row>
        <v-col cols="12" class="text-center">
          <v-btn class="mx-5" v-if="method !== 'VIEW'" @click="saveProduct" color="success">{{ $t("save") }}</v-btn>
          <v-btn class="mx-5" v-if="method === 'EDIT'" @click="deleteProduct" color="error">{{ $t("delete") }}</v-btn>
        </v-col>
      </v-row>
    </template>

    <v-container>
      <form>
        <v-row>
          <v-col md="8" cols="12" class="text-center">
            <v-row>
              <v-col md="4" cols="6">
                <v-text-field type="text" :disabled="method === 'VIEW'" v-model="productCode" :label="$t('product_code')"
                  :rules="required" hide-details="auto"></v-text-field>
              </v-col>

              <v-col v-if="type !== 'CREDITS'" md="1" cols="6">
                <v-text-field type="number" :disabled="method === 'VIEW'" v-model="prezzo" :label="$t('price')"
                  :rules="required" hide-details="auto"></v-text-field>
              </v-col>
              <v-col md="1" cols="6">
                <v-text-field type="number" :disabled="method === 'VIEW'" v-model="qta" :label="$t('quantity')"
                  :rules="required" hide-details="auto"></v-text-field>
              </v-col>
              <v-col md="2" cols="6">
                <v-switch :disabled="method === 'VIEW'" v-model="attivo" :label="$t('active_m_s')"></v-switch>
              </v-col>
              <v-col md="2" cols="6">
                <v-switch :disabled="method === 'VIEW'" v-model="autoEvasione" :label="$t('auto_evasion')"></v-switch>
              </v-col>
              <v-col md="2" cols="6">
                <v-switch :disabled="method === 'VIEW'" v-model="onlyTesserati"
                  :label="$t('only_for_affiliated')"></v-switch>
              </v-col>
              <v-col md="6" cols="12">
                <v-select v-model="modPag" :items="listPayment" :disabled="method === 'VIEW'"
                  :menu-props="{ maxHeight: '400' }" multiple required dense chips color="primary"
                  :hint="$t('pick_your_payments')" :label="$t('payment')" persistent-hint></v-select>
              </v-col>
              <v-col md="3" cols="6">
                <v-switch :disabled="method === 'VIEW'" v-model="buyWithCredits" :false-value="0" :true-value="1"
                  :label="$t('can_buy_with_credits')"></v-switch>
              </v-col>
              <v-col md="3" cols="12">
                <v-switch :disabled="method === 'VIEW'" v-model="forceOrderApprove"
                  :label="$t('force_order_approve')"></v-switch>
              </v-col>
              <v-col :cols="type !== 'TICKET' ? 12 : 6">
                <v-select v-model="type" :items="typeList" :disabled="method === 'VIEW'"
                  :menu-props="{ maxHeight: '400' }" :label="$t('typology')" required color="primary"
                  :hint="$t('select_product_type')" persistent-hint></v-select>
              </v-col>
              <v-col cols="6">
                <v-select v-if="type === 'TICKET'" v-model="idEvento" :items="eventList" :disabled="method === 'VIEW'"
                  :menu-props="{ maxHeight: '400' }" :label="$t('select_event')" required color="primary"
                  :hint="$t('select_event')" persistent-hint></v-select>
                <v-text-field v-if="type === 'digital'" type="text" :disabled="method === 'VIEW'" v-model="url"
                  :label="$t('url')" :rules="required" hide-details="auto"></v-text-field>
              </v-col>
              <v-col v-if="type === 'CREDITS'" cols="12">
                <v-row>
                  <v-col md="3" cols="12">
                    <v-switch :disabled="method === 'VIEW'" v-model="modeCredits" true-value="range" false-value="single"
                      :label="modeCredits === 'range' ? $t('range') : $t('single')"></v-switch>
                  </v-col>
                  <v-col md="3" cols="12" v-if="modeCredits === 'single'">
                    <v-text-field type="number" :disabled="method === 'VIEW'" v-model.number="maxCredits"
                      :label="$t('credits')" :rules="requiredNumber" hide-details="auto"></v-text-field>
                  </v-col>
                  <template v-if="modeCredits === 'range'">
                    <v-col md="3" cols="12">
                      <v-text-field type="number" :disabled="method === 'VIEW'" v-model.number="minCredits"
                        :label="$t('min_credits')" :rules="minCreditsRules" hide-details="auto"></v-text-field>
                    </v-col>
                    <v-col md="3" cols="12">
                      <v-text-field type="number" :disabled="method === 'VIEW'" v-model.number="maxCredits"
                        :label="$t('max_credits')" :rules="maxCreditsRules" hide-details="auto"></v-text-field>
                    </v-col>
                    <v-col md="3" cols="12">
                      <v-text-field type="number" :disabled="method === 'VIEW'" v-model.number="stepCredits"
                        :label="$t('step_credits')" :rules="stepCreditsRules" hide-details="auto"></v-text-field>
                    </v-col>
                  </template>
                </v-row>
              </v-col>
              <v-col :cols="ifEnte ? 10 : 12">
                <v-text-field type="text" :disabled="method === 'VIEW'" v-model="title" :label="$t('title')"
                  :rules="required" hide-details="auto"></v-text-field>
              </v-col>
              <v-col cols="2" v-if="ifEnte">
                <v-switch :disabled="method === 'VIEW'" v-model="showInAsd" :label="$t('show_in_asd')"></v-switch>
              </v-col>



              <v-col cols="12">
                <v-card>
                  <v-card-title>{{ $t("description") }}</v-card-title>
                  <v-card-text>
                    <tiptap-vuetify :extensions="extensions" :disabled="method === 'VIEW'"
                      v-model="descr"></tiptap-vuetify>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
          <v-col md="4" cols="12" class="text-center">
            <my-img-uploader ref="imageUploader" v-model="image" :readOnly="method === 'VIEW'" :width="600" :height="300"
              :placeholder="$t('click_drag_here')"></my-img-uploader>
          </v-col>
        </v-row>
        <v-row v-if="type !== 'PORTAL_REQUEST'">
          <v-col cols="12">
            <v-card>
              <v-card-title>
                <v-tooltip top v-if="method !== 'VIEW'">
                  <template v-slot:activator="{ on }">
                    <v-icon color="primary" large v-on="on" style="cursor: pointer" class="mr-2"
                      @click.native="addOption()">mdi-plus-circle-outline</v-icon>
                  </template>
                  <span>{{ $t("add_option") }}</span>
                </v-tooltip>
                {{ $t("options") }}
              </v-card-title>
              <v-spacer />
              <v-card-subtitle>{{
                $t("comma_separated_values")
              }}</v-card-subtitle>
              <v-card-text>
                <v-row v-for="opzione in options" v-bind:key="opzione.key">
                  <v-col md="4" cols="12">
                    <v-text-field type="text" :disabled="method === 'VIEW'" v-model="opzione.id" :label="$t('option')"
                      :rules="required" hide-details="auto">
                      <template v-if="method !== 'VIEW'" v-slot:prepend>
                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <v-icon color="error" large v-on="on" style="cursor: pointer" class="mr-2"
                              @click.native="deleteOption(opzione)">mdi-delete-outline</v-icon>
                          </template>
                          <span>{{ $t("delete_option") }}</span>
                        </v-tooltip>
                      </template>
                    </v-text-field>
                  </v-col>
                  <v-col md="8" cols="12">
                    <v-text-field type="text" :disabled="method === 'VIEW'" v-model="opzione.values" :label="$t('values')"
                      :rules="required" hide-details="auto"></v-text-field>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </form>
    </v-container>
  </base-dialog-form>
</template>
<script>
import Swal from "sweetalert2";
import MyImageUploader from "@/components/base/MyImageUploader.vue";

import {
  TiptapVuetify,
  Heading,
  Bold,
  Italic,
  Strike,
  Underline,
  Code,
  Paragraph,
  BulletList,
  OrderedList,
  ListItem,
  Link,
  Blockquote,
  HardBreak,
  HorizontalRule,
  History,
} from "tiptap-vuetify";
export default {
  name: "gest-product",
  components: {
    TiptapVuetify,
    "my-img-uploader": MyImageUploader,
  },
  data() {
    return {
      files: [],
      idProduct: null,
      method: null,
      productCode: null,
      title: null,
      descr: null,
      options: null,
      image: null,
      prezzo: null,
      qta: null,
      type: null,
      typeList: [],
      idEvento: null,
      url: null,
      eventList: [],
      modPag: [],
      listPayment: null,
      attivo: false,
      autoEvasione: false,
      showInAsd: false,
      onlyTesserati: false,
      buyWithCredits: 0,
      forceOrderApprove: false,
      modeCredits: "single",
      minCredits: null,
      maxCredits: null,
      stepCredits: 1,
      metadata: null,
      extensions: [
        History,
        Blockquote,
        Link,
        Underline,
        Strike,
        Italic,
        ListItem,
        BulletList,
        OrderedList,
        [
          Heading,
          {
            options: {
              levels: [1, 2, 3],
            },
          },
        ],
        Bold,
        Code,
        HorizontalRule,
        Paragraph,
        HardBreak,
      ],
      required: [(value) => !!value || this.$t("required_field")],
      requiredNumber: [
        (value) => (!!value && !isNaN(value)) || this.$t("required_field"),
      ],
    };
  },
  methods: {
    open(method, idProduct) {
      this.method = method;
      this.idProduct = idProduct;
      this.loadData();
      this.$refs.gestProductDialog.open();
    },
    addOption() {
      this.options.push({
        key: this.options.length + 1,
        id: "opzione-" + (this.options.length + 1),
        values: "",
      });
    },
    deleteOption(item) {
      this.options = this.options.filter((opzione) => {
        if (opzione.id !== item.id) return true;
        else return false;
      });
    },
    loadData() {
      let _ = this;
      _.listPayment = [];
      _.chiamataAxios("GET", "/auth/portal/listAllModPagamento").then(
        (response) => {
          _.listPayment = response.data
            .filter((pag) => {
              return pag.attivo === 1;
            })
            .map(function (item) {
              return { value: item.pagId, text: item.descr };
            });
        }
      );
      if (_.idProduct) {
        let url = "/auth/prodotti/getProduct/" + _.idProduct;
        _.chiamataAxios("GET", url).then((response) => {
          _.productCode = response.data.productCode;
          _.descr = response.data.descr;
          _.title = response.data.title;
          _.options = response.data.options.map((opzione) => {
            return {
              key: opzione.id,
              id: opzione.id,
              values: opzione.values.join(", "),
            };
          });
          _.idEvento = response.data.idEvento;
          _.type = response.data.type;
          _.url = response.data.url;
          _.prezzo = response.data.prezzo;
          _.qta = response.data.qta;
          _.metadata = response.data.metadata;
          _.image = response.data.image;
          _.attivo = response.data.attivo === 1 ? true : false;
          _.autoEvasione = response.data.autoEvasione === 1 ? true : false;
          _.showInAsd = response.data.showInAsd === 1 ? true : false;
          _.onlyTesserati = response.data.onlyTesserati === 1 ? true : false;
          _.buyWithCredits = Number(response.data.buyWithCredits) === 1 ? 1 : 0;
          _.forceOrderApprove = response.data.forceOrderApprove === 1 ? true : false;
          _.modPag = response.data.modPag;
          _.modeCredits = response.data.modeCredits || "single";
          _.minCredits = response.data.minCredits;
          _.maxCredits = response.data.maxCredits;
          _.stepCredits = response.data.stepCredits || 1;
        });
      } else {
        _.productCode = "";
        _.title = "";
        _.descr = "";
        _.options = [];
        _.idEvento = null;
        _.type = null;
        _.url = null;
        _.prezzo = 0;
        _.qta = 0;
        _.metadata = [];
        _.image = null;
        _.modPag = [];
        _.attivo = true;
        _.onlyTesserati = false;
        _.buyWithCredits = 0;
        _.showInAsd = false;
        _.autoEvasione = false;
        _.forceOrderApprove = false;
        _.modeCredits = "single";
        _.minCredits = null;
        _.maxCredits = null;
        _.stepCredits = 1;
      }

      // Tipologie prodotto
      _.typeList = [
        {
          value: "PRODUCT",
          text: this.$t("product"),
        },
        {
          value: "DIGITAL",
          text: this.$t("digital"),
        },
        {
          value: "CREDITS",
          text: this.$t("credits"),
        }
      ];

      if (_.ifEnte) {
        _.typeList.push({
          value: "PORTAL_REQUEST",
          text: this.$t("portal_request"),
        });
      }

      // Lista eventi attivi
      _.eventList = [];
      if (_.checkEnabledModule("eventi")) {
        _.typeList.push({
          value: "TICKET",
          text: this.$t("event_ticket"),
        });

        _.chiamataAxios("GET", "/auth/eventi/listEventi/all").then((response) => {
          _.eventList = response.data.eventi.map((evento) => {
            return {
              value: evento.idEvento,
              text:
                evento.titolo +
                " - " +
                new Date(evento.dateInz).toLocaleDateString(),
            };
          });
        });
      }
    },
    normalizeCreditsFields() {
      if (this.type !== "CREDITS") {
        this.modeCredits = "single";
        this.minCredits = null;
        this.maxCredits = null;
        this.stepCredits = 1;
        return;
      }

      if (this.modeCredits === "single") {
        this.minCredits = this.maxCredits;
        this.stepCredits = 1;
      }

      if (!this.stepCredits || this.stepCredits <= 0) {
        this.stepCredits = 1;
      }
    },
    validateCreditsBeforeSave() {
      if (this.type !== "CREDITS") return true;

      if (this.modeCredits === "single") {
        if (this.maxCredits === null || this.maxCredits === "" || isNaN(this.maxCredits)) {
          Swal.fire({ type: "error", html: "<strong>Max credits obbligatorio</strong>" });
          return false;
        }
        return true;
      }

      const min = Number(this.minCredits);
      const max = Number(this.maxCredits);
      const step = Number(this.stepCredits);

      if (isNaN(min) || isNaN(max) || isNaN(step)) {
        Swal.fire({ type: "error", html: "<strong>Compilare min, max e step credits</strong>" });
        return false;
      }
      if (min > max) {
        Swal.fire({ type: "error", html: "<strong>Min credits non pu\u00f2 essere maggiore di max credits</strong>" });
        return false;
      }
      if (step <= 0) {
        Swal.fire({ type: "error", html: "<strong>Step credits deve essere maggiore di 0</strong>" });
        return false;
      }
      return true;
    },
    deleteProduct(item) {
      let _ = this;
      Swal.fire({
        title: this.$t("are_you_sure_?"),
        text: this.$t("you_cant_revert_this"),
        type: "warning",
        showCancelButton: true,
        customClass: "v-application",
        confirmButtonClass:
          "mx-5 v-btn v-btn--contained theme--light v-size--default",
        cancelButtonClass:
          "mx-5 v-btn v-btn--contained theme--light v-size--default",
        confirmButtonText: this.$t("yes_delete"),
        cancelButtonText: this.$t("back"),
        buttonsStyling: true,
      }).then((result) => {
        if (result.value) {
          this.chiamataAxios(
            "DELETE",
            "/auth/prodotti/deleteProduct/" + _.idProduct,
            { msg: "always" }
          ).then((response) => {
            if (response.msg.esito) {
              _.$emit("isUpdated", "true");
              _.$refs.gestProductDialog.close();
            }
          });
        }
      });
    },
    saveProduct: function () {
      let _ = this;
      _.normalizeCreditsFields();
      if (!_.validateCreditsBeforeSave()) return;
      _.$refs.imageUploader.updateImage();
      let url = "/auth/prodotti/saveProduct/" + _.idProduct;
      let method = "POST";
      if (_.method == "ADD") {
        url = "/auth/prodotti/createProduct";
        method = "PUT";
      }
      _.chiamataAxios(method, url, {
        dialogLoader: true,
        body: {
          productCode: _.productCode,
          title: _.title,
          descr: _.descr,
          options: _.options.map((opzione) => {
            return { id: opzione.id, values: opzione.values.split(",") };
          }),
          idEvento: _.idEvento,
          type: _.type,
          url: _.url,
          prezzo: _.prezzo,
          qta: _.qta,
          minCredits: _.type === "CREDITS" ? (_.modeCredits === "single" ? _.maxCredits : _.minCredits) : null,
          maxCredits: _.type === "CREDITS" ? _.maxCredits : null,
          stepCredits: _.type === "CREDITS" ? (_.modeCredits === "single" ? 1 : _.stepCredits) : null,
          metadata: _.metadata,
          image: _.image,
          attivo: _.attivo ? 1 : 0,
          showInAsd: _.showInAsd && _.ifEnte ? 1 : 0,
          autoEvasione: _.autoEvasione ? 1 : 0,
          onlyTesserati: _.onlyTesserati ? 1 : 0,
          buyWithCredits: _.buyWithCredits,
          forceOrderApprove: _.forceOrderApprove ? 1 : 0,
          modPag: _.modPag,
        },
      }).then((response) => {
        if (response.msg.esito) {
          let html = "<strong>" + response.msg.msgTxt + "</strong>";
          Swal.fire({
            type: "success",
            html: html,
          });
          _.$emit("isUpdated", "true");
          _.$refs.gestProductDialog.close();
        }
      });
    },
  },
  watch: {
    type() {
      this.normalizeCreditsFields();
    },
    modeCredits() {
      this.normalizeCreditsFields();
    },
    maxCredits(value) {
      if (this.type === "CREDITS" && this.modeCredits === "single") {
        this.minCredits = value;
      }
    },
  },
  computed: {
    minCreditsRules: function () {
      return [
        ...this.requiredNumber,
        (value) => this.modeCredits !== "range" || Number(value) <= Number(this.maxCredits) || "Min credits deve essere <= Max credits",
      ];
    },
    maxCreditsRules: function () {
      return [
        ...this.requiredNumber,
        (value) => this.modeCredits !== "range" || Number(value) >= Number(this.minCredits) || "Max credits deve essere >= Min credits",
      ];
    },
    stepCreditsRules: function () {
      return [
        ...this.requiredNumber,
        (value) => Number(value) > 0 || "Step credits deve essere > 0",
      ];
    },
    ifEnte: function () {
      return window.systemData && window.systemData.ifEnte
        ? window.systemData.ifEnte
        : false;
    },
    computedTitle: function () {
      if (this.method === "EDIT") return this.$t("edit_product");
      else if (this.method === "VIEW") return this.$t("view_product");
      else if (this.method === "ADD") return this.$t("create_product");
      else return "";
    },
  },
};
</script>
